export const getMenuCategories = /* GraphQL */ `
  query SearchProductCategories(
    $filter: SearchableProductCategoryFilterInput
    $sort: [SearchableProductCategorySortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductCategoryAggregationInput]
  ) {
    searchProductCategories(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        slug
        priority
        isFeatured
        isArchive
        storeId
        imageUrl
        metadata {
          title
          description
          keywords
          image
          canonical
          noIndex
        }
      }
    }
  }
`;

export const getSubCategoriesByCategoryID = /* GraphQL */ `
  query SearchProductSubCategories(
    $filter: SearchableProductCategoryFilterInput
    $sort: [SearchableProductCategorySortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductCategoryAggregationInput]
  ) {
    searchProductCategories(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        slug
        priority
        isFeatured
        isArchive
        storeId
        imageUrl
        categoryID
        metadata {
          title
          description
          keywords
          image
          canonical
          noIndex
        }
      }
    }
  }
`;

export const getAllCategoriesPath = /* GraphQL */ `
  query SearchProductCategories(
    $filter: SearchableProductCategoryFilterInput
    $sort: [SearchableProductCategorySortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductCategoryAggregationInput]
  ) {
    searchProductCategories(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        slug
      }
    }
  }
`;

export const getAllCollectionPath = /* GraphQL */ `
  query SearchCollectionTypes(
    $filter: SearchableCollectionTypeFilterInput
    $sort: [SearchableCollectionTypeSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCollectionTypeAggregationInput]
  ) {
    searchCollectionTypes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        slug
      }
    }
  }
`;

export const getHomePageCategories = /* GraphQL */ `
  query SearchProductSubCategories(
    $filter: SearchableProductCategoryFilterInput
    $sort: [SearchableProductCategorySortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductCategoryAggregationInput]
  ) {
    searchProductCategories(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        slug
        imageUrl
        priority
        isArchive
        metadata {
          title
          description
          keywords
          image
          canonical
          noIndex
        }
      }
    }
  }
`;

export const getQuickViewProduct = /* GraphQL */ `
  query ByslugProduct(
    $slug: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
    $variantFilter: ModelVariantFilterInput
  ) {
    byslugProduct(
      slug: $slug
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        minimumOrderQuantity
        maximumOrderQuantity
        variantGroups {
          variantGroupId
          variantGroupOptionIds
        }
        title
        collections
        isFeatured
        categoryId
        subCategoryId
        category {
          id
          name
          slug
        }
        productType
        slug
        productDescription
        price
        sku
        size
        color
        status
        position
        currency
        costPrice
        listingPrice
        taxable
        barcode
        tags
        benefits
        weight
        weightUnit
        inventory
        blockedInventory
        rating
        totalRatings
        totalOrders
        thumbImages
        isTaxEnabled
        isInventoryEnabled
        continueSellingOutOfStock
        hasVarient
        variants(filter: $variantFilter) {
          items {
            id
            minimumOrderQuantity
            maximumOrderQuantity
            productId
            title
            price
            sku
            size
            color
            status
            position
            currency
            costPrice
            listingPrice
            thumbImage
            createdAt
            updatedAt
            taxable
            barcode
            images {
              items {
                id
                productId
                position
                createdAt
                updatedAt
                alt
                width
                height
                imageKey
                isThumb
              }
            }
            weight
            weightUnit
            inventory
            blockedInventory
            productVariantOptionIds {
              variantGroupId
              variantGroupOptionId
            }
          }
          nextToken
        }
        images {
          items {
            id
            productId
            position
            createdAt
            updatedAt
            alt
            width
            height
            imageKey
            isThumb
          }
        }
      }

      nextToken
    }
  }
`;

export const getProductBySlug = /* GraphQL */ `
  query ByslugProduct(
    $slug: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
    $variantFilter: ModelVariantFilterInput
  ) {
    byslugProduct(
      slug: $slug
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        minimumOrderQuantity
        maximumOrderQuantity
        variantGroups {
          variantGroupId
          variantGroupOptionIds
        }
        title
        brand
        label
        labelColor
        vendor
        collections
        isFeatured
        isFeedEnabled
        isSearchFeedEnabled
        isAtcEnabled
        showOnlyVariantImages
        categoryId
        subCategoryId
        category {
          id
          name
          slug
        }
        productType
        createdAt
        slug
        pageTitle
        productDescription
        longDescription
        manufacturer
        updatedAt
        isPublished
        publishedAt
        price
        sku
        size
        color
        status
        position
        currency
        costPrice
        listingPrice
        taxable
        barcode
        tags
        benefits
        weight
        weightUnit
        inventory
        blockedInventory
        rating
        totalRatings
        totalOrders
        additionalInfo {
          label
          value
        }
        thumbImages
        isTaxEnabled
        isInventoryEnabled
        metadata {
          title
          description
          keywords
          image
          canonical
          noIndex
        }
        continueSellingOutOfStock
        hasVarient
        hasFaq
        variants(filter: $variantFilter) {
          items {
            id
            minimumOrderQuantity
            maximumOrderQuantity
            productId
            title
            price
            sku
            size
            color
            status
            position
            currency
            costPrice
            thumbImage
            listingPrice
            createdAt
            updatedAt
            taxable
            barcode
            images {
              items {
                id
                productId
                position
                createdAt
                updatedAt
                alt
                width
                height
                imageKey
                isThumb
              }
            }
            weight
            weightUnit
            inventory
            blockedInventory
            productVariantOptionIds {
              variantGroupId
              variantGroupOptionId
            }
          }
          nextToken
        }
        images {
          items {
            id
            productId
            position
            createdAt
            updatedAt
            alt
            width
            height
            imageKey
            isThumb
          }
        }
      }
      nextToken
    }
  }
`;
export const getFeaturedCoupon = /* GraphQL */ `
  query SearchCoupons(
    $filter: SearchableCouponFilterInput
    $sort: [SearchableCouponSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCouponAggregationInput]
  ) {
    searchCoupons(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        description
        code
        couponType
        buyXQuantity
        isAffiliated
        isFeatured
        isPDPFeatured
        expirationDate
        showAsNudge
        ppcodCouponAmount
        getYAmount
        getYPercentage
        getYQuantity
        getYProducts
        getYStoreProducts {
          id
          title
          price
        }
        minOrderValue
        maxDiscount
        expirationDate
        autoApply
        applicableCollections
        applicableProducts
        paymentMethod
      }
    }
  }
`;

export const applyCoupon = /* GraphQL */ `
  mutation ApplyCoupon(
    $storeId: ID!
    $code: String!
    $deviceType: ApplCouponDeviceType!
    $variantFilter: ModelVariantFilterInput
    $variantLimit: Int
    $imageLimit: Int
  ) {
    applyCoupon(storeId: $storeId, code: $code, deviceType: $deviceType) {
      id
      code
      couponType
      buyXQuantity
      isAffiliated
      isPDPFeatured
      showAsNudge
      ppcodCouponAmount
      getYAmount
      getYPercentage
      getYQuantity
      getYProducts
      applyOnAllVariants
      ppcodCouponAmount
      getYStoreProducts {
        id
        title
        collections
        vendor
        isFeatured
        slug
        price
        sku
        position
        listingPrice
        tags
        inventory
        blockedInventory
        continueSellingOutOfStock
        rating
        totalRatings
        thumbImages
        isInventoryEnabled
        totalOrders
        variants(filter: $variantFilter, limit: $variantLimit) {
          items {
            id
            title
            price
            position
            listingPrice
            images {
              items {
                id
                productId
                position
                createdAt
                updatedAt
                alt
                width
                height
                imageKey
                isThumb
              }
            }
            inventory
            blockedInventory
          }
        }
        images(limit: $imageLimit) {
          items {
            id
            position
            alt
            width
            height
            imageKey
            isThumb
          }
        }
      }
      minOrderValue
      maxDiscount
      applicableCollections
      applicableProducts
      paymentMethod
      applyPrepaidDiscount
      couponTitle
      description
      autoApply
      deviceType
      isFeatured
      isArchive
      priority
      createdAt
    }
  }
`;

export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      code
      storeId
      userId
      channelName
      shippingAddress {
        name
        country
        state
        city
        pinCode
        landmark
        address
        location
        area
      }
      appliedRewardPoints
      billingAddress {
        name
        country
        state
        city
        pinCode
        landmark
        address
        location
        area
      }
      totalStoreCredit
      couponCodeId
      totalAmount
      totalCashOnDeliveryCharges
      totalDiscount
      totalGiftCharges
      totalPrepaidAmount
      totalShippingCharges
      taxExempted
      cFormProvided
      thirdPartyShipping
      totalCashbackRefunded
      cashbackEarned
      currency
      prepaidDiscount
      paymentType
      sla
      priority
      orderDate
      status
      source
      checkoutChannel
      products {
        items {
          id
          productId
          product {
            id
            title
            slug
            productDescription
            price
            sku
            status
            costPrice
            listingPrice
            totalOrders
            images {
              items {
                id
                alt
                width
                height
                imageKey
                isThumb
              }
            }
          }
          variantId
          variant {
            id
            productId
            title
            price
            status
            costPrice
            listingPrice
            images {
              items {
                id
                alt
                width
                height
                imageKey
                isThumb
              }
            }
          }
          sku
          cancelledQuantity
          quantity
          price
          status
          deliveryPartner
          shippingCourier
          trackingId
        }
      }
      payments {
        items {
          id
          orderId
          method
          status
          amount
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const getOrderSuccess = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      code
      totalAmount
      totalDiscount
      totalShippingCharges
      totalCashOnDeliveryCharges
    }
  }
`;

export const getOrderStatus = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      code
      status
    }
  }
`;
export const searchProductSubCategories = /* GraphQL */ `
  query SearchProductSubCategories(
    $filter: SearchableProductCategoryFilterInput
    $sort: [SearchableProductCategorySortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductCategoryAggregationInput]
  ) {
    searchProductSubCategories(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        categoryID
        category {
          id
          name
          description
          slug

          createdAt
          updatedAt
        }
        isArchive
        slug
      }
      nextToken
      total
    }
  }
`;

export const getBasicSubCategory = /* GraphQL */ `
  query ByslugProductSubCategory(
    $slug: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byslugProductSubCategory(
      slug: $slug
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        title
        description
        slug
        bannerUrl
        categoryID
        imageUrl
        isArchive
        category {
          slug
        }
      }
    }
  }
`;

export const getBasicCategory = /* GraphQL */ `
  query ByslugProductCategory(
    $slug: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byslugProductCategory(
      slug: $slug
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        title
        description
        slug
        imageUrl
        isArchive
        bannerUrl
        categoryID
        metadata {
          title
          description
          keywords
          image
          canonical
          noIndex
        }
      }
    }
  }
`;

export const findProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: [SearchableProductSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductAggregationInput]
    $variantFilter: ModelVariantFilterInput
    $variantLimit: Int
    $imageLimit: Int
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        minimumOrderQuantity
        maximumOrderQuantity
        title
        collections
        vendor
        label
        labelColor
        status
        isFeatured
        category {
          name
          slug
        }
        benefits
        slug
        price
        sku
        position
        collectionsList {
          label
          labelColor
          priority
          slug
        }
        listingPrice
        tags
        inventory
        blockedInventory
        defaultPrice
        defaultInventory
        subCategoryId
        showOnlyVariantImages
        variantGroups {
          variantGroupId
          variantGroupOptionIds
        }

        continueSellingOutOfStock
        metadata {
          title
          description
          keywords
          image
          canonical
          noIndex
        }
        rating
        totalRatings
        thumbImages
        isInventoryEnabled
        totalOrders
        recommended
        recommendPriority
        recommendPrice
        variants(filter: $variantFilter, limit: $variantLimit) {
          items {
            id
            minimumOrderQuantity
            maximumOrderQuantity
            title
            price
            position
            listingPrice
            productVariantOptionIds {
              variantGroupId
              variantGroupOptionId
            }
            thumbImage
            images {
              items {
                id
                productId
                position
                createdAt
                updatedAt
                alt
                width
                height
                imageKey
                isThumb
              }
            }
            inventory
            blockedInventory
            status
          }
        }
        images(limit: $imageLimit) {
          items {
            id
            position
            alt
            width
            height
            imageKey
            isThumb
          }
        }
      }
      nextToken
      total
    }
  }
`;

export const getProductById = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      minimumOrderQuantity
      maximumOrderQuantity
      title
      collections
      vendor
      label
      labelColor
      subCategory {
        name
        slug
      }
      isFeatured
      category {
        name
        slug
      }
      slug
      price
      sku
      position
      listingPrice
      tags
      inventory
      blockedInventory
      continueSellingOutOfStock
      showOnlyVariantImages
      rating
      totalRatings
      thumbImages
      isInventoryEnabled
      totalOrders
      variantGroups {
        variantGroupId
        variantGroupOptionIds
      }
      variants {
        items {
          id
          minimumOrderQuantity
          maximumOrderQuantity
          title
          price
          position
          listingPrice
          productVariantOptionIds {
            variantGroupId
            variantGroupOptionId
          }
          images {
            items {
              id
              position
              alt
              width
              height
              imageKey
              isThumb
            }
          }
          thumbImage
          inventory
          blockedInventory
        }
      }
      images {
        items {
          id
          position
          alt
          width
          height
          imageKey
          isThumb
        }
      }
    }
  }
`;

export const getLoyalty = /* GraphQL */ `
  query GetLoyalty($input: GetLoyaltyInput!) {
    getLoyalty(input: $input) {
      totalAllotted
      totalUsable
      totalUsed
      totalExpired
      transactions {
        id
        amount
        userId
        expiresAt
        expirePeriodInDays
        event
        ruleId
        status
        transactionState
        createdAt
        updatedAt
        metadata
        reason
      }
    }
  }
`;

//     posts(first: 3, where: { tagSlugIn: "english", status: PUBLISH }) {
export const getFeaturedBlogs = /* GraphQL */ `
  query FeatueredBlogs {
    posts(first: 3) {
      edges {
        node {
          date
          id
          databaseId
          slug
          status
          title
          uri
          excerpt
          toPing
          link
          featuredImage {
            node {
              mediaItemUrl
            }
          }
        }
      }
    }
  }
`;

export const getAuthor = /* GraphQL */ `
  query Author($id: ID!, $idType: UserNodeIdTypeEnum!) {
    user(id: $id, idType: $idType) {
      nicename
      email
      description
      firstName
      lastName
      name
      nickname
      slug
      username
      url
      uri
      avatar {
        url
        height
        width
      }
      seo {
        social {
          facebook
          instagram
          linkedIn
          mySpace
          pinterest
          soundCloud
          twitter
          wikipedia
          youTube
        }
        title
        canonical
      }
    }
  }
`;
export const getAuthors = /* GraphQL */ `
  query GetAuthors {
    users {
      edges {
        node {
          slug
          nicename
          name
        }
      }
    }
  }
`;

export const getBlogs = /* GraphQL */ `
  query GetBlogs(
    $category: String
    $tag: [String]
    $first: Int
    $last: Int
    $after: String
    $before: String
    $authorName: String
  ) {
    posts(
      where: {
        categoryName: $category
        tagSlugIn: $tag
        status: PUBLISH
        authorName: $authorName
      }
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          databaseId
          slug
          seo {
            readingTime
          }
          title
          uri
          excerpt
          link
          date
          featuredImage {
            node {
              mediaItemUrl
            }
          }
          author {
            node {
              name
              slug
              avatar {
                url
                height
                width
              }
              seo {
                social {
                  facebook
                  instagram
                  mySpace
                  linkedIn
                  pinterest
                  soundCloud
                  twitter
                  wikipedia
                  youTube
                }
              }
              username
              nicename
            }
          }
        }
      }
    }
  }
`;

export const getBlog = /* GraphQL */ `
  query GetBlogBySlug($id: ID!, $idType: PostIdType!) {
    post(id: $id, idType: $idType) {
      id
      databaseId
      slug
      title
      uri
      excerpt
      link
      date
      seo {
        metaDesc
        readingTime
      }
      featuredImage {
        node {
          mediaItemUrl
        }
      }
      categories {
        nodes {
          name
          slug
        }
      }
      tags {
        nodes {
          name
          slug
          seo {
            metaDesc
          }
        }
      }
      content
      author {
        node {
          name
          slug
          description
          avatar {
            url
            height
            width
          }
          seo {
            social {
              facebook
              instagram
              mySpace
              linkedIn
              pinterest
              soundCloud
              twitter
              wikipedia
              youTube
            }
          }
          username
          nicename
        }
      }
    }
  }
`;

export const getCategories = /* GraphQL */ `
  query GetCategories {
    categories {
      edges {
        node {
          id
          databaseId
          slug
          name
        }
      }
    }
  }
`;

export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    category(id: $id, idType: SLUG) {
      id
      databaseId
      slug
      name
    }
  }
`;

// id: "dGVybTo1Mw==", idType: ID
// menu(id: "dGVybTo1Mw==", idType: ID)
export const getTopMenu = /* GraphQL */ `
  query GetMenu {
    menu() {
      id
      menuItems {
        nodes {
          id
          label
          path
        }
      }
    }
  }
`;

export const getTags = /* GraphQL */ `
  query GetTags {
    tags {
      edges {
        node {
          id
          slug
          name
        }
      }
    }
  }
`;

export const getTag = `
query GetTag($id: ID!) {
  tag(id: $id, idType: SLUG) {
    id
    slug
    name
  }
}
`;
// export const getRecommendedProductById = /* GraphQL */ `
//   query GetProduct(
//     $id: ID!
//     $variantFilter: ModelVariantFilterInput
//     $variantLimit: Int
//     $imageLimit: Int
//   ) {
//     getProduct(id: $id) {
//       id
//       title
//       collections
//       vendor
//       subCategory {
//         name
//         slug
//       }
//       isFeatured
//       category {
//         name
//         slug
//       }
//       slug
//       price
//       sku
//       status
//       collectionsList {
//         label
//       }
//       position
//       listingPrice
//       tags
//       inventory
//       blockedInventory
//       continueSellingOutOfStock
//       rating
//       totalRatings
//       thumbImages
//       isInventoryEnabled
//       totalOrders
//       variants(filter: $variantFilter, limit: $variantLimit) {
//         items {
//           id
//           title
//           price
//           position
//           listingPrice
//           imageUrl
//           inventory
//           blockedInventory
//         }
//       }
//       images(limit: $imageLimit) {
//         items {
//           id
//           position
//           alt
//           width
//           height
//           imageKey
//           isThumb
//         }
//       }
//     }
//   }
// `;

export const getProductSlug = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: [SearchableProductSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductAggregationInput]
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        slug
      }
    }
  }
`;

export const searchProductsBasic = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: [SearchableProductSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductAggregationInput]
    $imageLimit: Int
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        minimumOrderQuantity
        maximumOrderQuantity
        title
        collections
        slug
        price
        sku
        listingPrice
        thumbImages
        images(limit: $imageLimit) {
          items {
            id
            position
            alt
            width
            height
            imageKey
            isThumb
          }
        }
      }
    }
  }
`;

export const createReview = /* GraphQL */ `
  mutation CreateReview($input: CreateReviewInput!) {
    createReview(input: $input) {
      id
      userId
      verified
      reviewer {
        name
        email
      }
      productId
      rating
      comment
      title
      images
      createdAt
    }
  }
`;

export const updateReview = /* GraphQL */ `
  mutation UpdateReview($input: UpdateReviewInput!) {
    updateReview(input: $input) {
      id
      userId
      verified
      reviewer {
        name
        email
      }
      productId
      rating
      comment
      title
      images
      createdAt
    }
  }
`;

export const byorderIdcreatedAtPayment = /* GraphQL */ `
  query ByorderIdcreatedAtPayment(
    $orderId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byorderIdcreatedAtPayment(
      orderId: $orderId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeId
        userId
        orderId
        method
        status
        amount
        paymentDate
        createdAt
        updatedAt
      }
    }
  }
`;

export const createShoppingCartProduct = /* GraphQL */ `
  mutation CreateShoppingCartProduct($input: CreateShoppingCartProductInput!) {
    createShoppingCartProduct(input: $input) {
      id
      shoppingcartId
      productId
      variantId
      quantity
    }
  }
`;
export const updateShoppingCartProduct = /* GraphQL */ `
  mutation UpdateShoppingCartProduct($input: UpdateShoppingCartProductInput!) {
    updateShoppingCartProduct(input: $input) {
      id
      shoppingcartId
      productId
      variantId
      quantity
    }
  }
`;
export const deleteShoppingCartProduct = /* GraphQL */ `
  mutation DeleteShoppingCartProduct($input: DeleteShoppingCartProductInput!) {
    deleteShoppingCartProduct(input: $input) {
      id
      shoppingcartId
      productId
      variantId
      quantity
      updatedAt
    }
  }
`;

export const createShoppingCart = /* GraphQL */ `
  mutation CreateShoppingCart($input: CreateShoppingCartInput!) {
    createShoppingCart(input: $input) {
      success
      message
      shoppingCartId
    }
  }
`;

export const updateShoppingCart = /* GraphQL */ `
  mutation UpdateShoppingCart($input: UpdateShoppingCartInput!) {
    updateShoppingCart(input: $input) {
      id
      storeId
      userId
      couponCodeId
    }
  }
`;

export const deleteShoppingCart = /* GraphQL */ `
  mutation DeleteShoppingCart($input: DeleteShoppingCartInput!) {
    deleteShoppingCart(input: $input) {
      id
    }
  }
`;

export const findUserAddresses = /* GraphQL */ `
  query SearchUserAddresses(
    $filter: SearchableUserAddressFilterInput
    $sort: [SearchableUserAddressSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserAddressAggregationInput]
  ) {
    searchUserAddresses(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        userID
        name
        phone
        email
        country
        state
        city
        pinCode
        landmark
        address
        location
        area
        createdAt
        updatedAt
      }
      total
    }
  }
`;

export const createUserAddress = /* GraphQL */ `
  mutation CreateUserAddress($input: CreateUserAddressInput!) {
    createUserAddress(input: $input) {
      id
      userID
      name
      phone
      email
      country
      state
      city
      pinCode
      landmark
      address
      location
      area
      createdAt
      updatedAt
    }
  }
`;

export const updateUserAddress = /* GraphQL */ `
  mutation UpdateUserAddress($input: UpdateUserAddressInput!) {
    updateUserAddress(input: $input) {
      id
      userID
      name
      phone
      email
      country
      state
      city
      pinCode
      landmark
      address
      location
      area
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserAddress = /* GraphQL */ `
  mutation DeleteUserAddress($input: DeleteUserAddressInput!) {
    deleteUserAddress(input: $input) {
      id
      userID
      name
      phone
      email
      country
      state
      city
      pinCode
      landmark
      address
      location
      area
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const searchOrders = /* GraphQL */ `
  query SearchOrders(
    $filter: SearchableOrderFilterInput
    $sort: [SearchableOrderSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableOrderAggregationInput]
  ) {
    searchOrders(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        code
        totalAmount
        orderDate
        status
        createdAt
      }
      nextToken
      total
    }
  }
`;

export const getUser = /* GraphQL */ `
  query GetUser {
    getUser {
      id
      owner
      firstName
      lastName
      email
      phone
      gender
      dob
      totalOrders
      isActive
      authProvider
      isAdmin
      profilePhotoUrl
      emailVerified
      phoneVerified
      isCognitoConfirmed
      createdAt
      updatedAt
      totalOrders
    }
  }
`;

export const getUserRewards = /* GraphQL */ `
  query GetUser($storeId: ID) {
    getUser(storeId: $storeId) {
      id
      totalRewards
    }
  }
`;

export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      owner
      firstName
      lastName
      email
      phone
      gender
      dob
      isActive
      authProvider
      isAdmin
      profilePhotoUrl
      emailVerified
      phoneVerified
      isCognitoConfirmed
      createdAt
      updatedAt
    }
  }
`;

export const createTransaction = /* GraphQL */ `
  mutation CreateTransaction($orderId: ID!) {
    createTransaction(orderId: $orderId) {
      orderId
      amount
    }
  }
`;

export const getStore = /* GraphQL */ `
  query GetStore($id: ID!, $deviceType: DeviceType!) {
    getStore(id: $id, deviceType: $deviceType) {
      id
      name
      title
      description
      isActive
      webUrl
      imageUrl
      darkImageUrl
      banners {
        webKey
        mobileKey
        link
        name
        isArchive
        priority
        isThankYouPageBanner
      }
      announcements {
        label
        link
        color
        textColor
        isArchive
      }
      socialLinks {
        instagram
        facebook
        twitter
        youtube
        pinterest
      }
      createdAt
      updatedAt
    }
  }
`;

export const getStoreBanners = /* GraphQL */ `
  query GetStore($id: ID!, $deviceType: DeviceType!) {
    getStore(id: $id, deviceType: $deviceType) {
      title
      name
      description
      webUrl
      imageUrl
      banners {
        webKey
        mobileKey
        link
        name
        isArchive
        priority
        isThankYouPageBanner
      }
      announcements {
        label
        link
        color
        textColor
        isArchive
      }
    }
  }
`;

export const validateTransaction = /* GraphQL */ `
  mutation ValidateTransaction($orderId: ID!, $razorpayPaymentId: String!) {
    validateTransaction(
      orderId: $orderId
      razorpayPaymentId: $razorpayPaymentId
    ) {
      success
    }
  }
`;

export const getZipCode = /* GraphQL */ `
  query GetZipCode($id: ID!) {
    getZipCode(id: $id) {
      id
      codMaxAmount
      cod
      prepaid
      createdAt
      updatedAt
    }
  }
`;

export const getReviews = /* GraphQL */ `
  query SearchReviews(
    $filter: SearchableReviewFilterInput
    $sort: [SearchableReviewSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableReviewAggregationInput]
  ) {
    searchReviews(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        userId
        verified
        reviewer {
          name
          email
        }
        productId
        rating
        comment
        title
        images
        createdAt
      }
      nextToken
      total
    }
  }
`;

export const getReviewsAnalytics = /* GraphQL */ `
  query SearchReviews(
    $filter: SearchableReviewFilterInput
    $sort: [SearchableReviewSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableReviewAggregationInput]
  ) {
    searchReviews(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const getLinkedProducts = /* GraphQL */ `
  query ByProductIdLinkedProduct(
    $productId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLinkedProductFilterInput
    $limit: Int
    $nextToken: String
    $variantFilter: ModelVariantFilterInput
    $variantLimit: Int
    $imageLimit: Int
  ) {
    byProductIdLinkedProduct(
      productId: $productId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        linkedProductId
        linkedProduct {
          id
          title
          brand
          slug
          productDescription
          price
          sku
          size
          position
          currency
          costPrice
          listingPrice
          taxable
          barcode
          tags
          benefits
          rating
          totalRatings
          totalOrders
          thumbImages
          isTaxEnabled
          isInventoryEnabled
          hasVarient
          variants(filter: $variantFilter, limit: $variantLimit) {
            items {
              id
              title
              price
              sku
              position
              currency
              costPrice
              listingPrice
              thumbImage
              images {
                items {
                  id
                  productId
                  position
                  createdAt
                  updatedAt
                  alt
                  width
                  height
                  imageKey
                  isThumb
                }
              }
            }
          }
          images(limit: $imageLimit) {
            items {
              id
              productId
              position
              createdAt
              updatedAt
              alt
              width
              height
              imageKey
              isThumb
            }
          }
        }
      }
    }
  }
`;

export const addProductNotification = /* GraphQL */ `
  mutation AddProductNotification(
    $productId: ID!
    $variantId: ID
    $userId: ID
    $email: AWSEmail
  ) {
    addProductNotification(
      productId: $productId
      variantId: $variantId
      userId: $userId
      email: $email
    ) {
      success
      message
    }
  }
`;

export const getHomePageBlogs = /* GraphQL */ `
  query SearchBlogs(
    $filter: SearchableBlogFilterInput
    $sort: [SearchableBlogSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableBlogAggregationInput]
  ) {
    searchBlogs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        title
        content
        excerpt
        featuredImage
        tags
        isVisible
        seo {
          pageURL
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const searchCollectionTypes = /* GraphQL */ `
  query SearchCollectionTypes(
    $filter: SearchableCollectionTypeFilterInput
    $sort: [SearchableCollectionTypeSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCollectionTypeAggregationInput]
  ) {
    searchCollectionTypes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        slug
        name
        title
        description
        priority
        imageUrl
        defaultSorting
        showOutOfStockProducts
        isArchive
        bannerUrl
        metadata {
          title
          description
          keywords
          image
          canonical
          noIndex
        }
      }
    }
  }
`;

export const searchShippingTiers = /* GraphQL */ `
  query SearchShippingTiers(
    $filter: SearchableShippingTierFilterInput
    $sort: [SearchableShippingTierSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableShippingTierAggregationInput]
  ) {
    searchShippingTiers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        storeId
        paymentType
        amount
        minOrderValue
        maxOrderValue
        createdAt
        updatedAt
      }
    }
  }
`;

export const checkInventory = /* GraphQL */ `
  mutation CheckInventory($storeId: ID!, $items: [CheckInventoryInput!]!) {
    checkInventory(storeId: $storeId, items: $items) {
      recordKey
      productId
      variantId
      inventory
      price
      collections
      maximumOrderQuantity
      minimumOrderQuantity
      __typename
    }
  }
`;

export const getRedirects = /* GraphQL */ `
  query GetRedirects($slug: String!, $storeId: ID!) {
    getRedirects(slug: $slug, storeId: $storeId) {
      slug
      redirect
      hitCount
    }
  }
`;

export const createRedirects = /* GraphQL */ `
  mutation CreateRedirects($input: CreateRedirectsInput!) {
    createRedirects(input: $input) {
      id
    }
  }
`;

export const updateRedirects = /* GraphQL */ `
  mutation UpdateRedirects($input: UpdateRedirectsInput!) {
    updateRedirects(input: $input) {
      id
      storeId
      slug
      hitCount
      redirect
      updatedAt
    }
  }
`;

export const searchConfigurations = /* GraphQL */ `
  query SearchConfigurations(
    $filter: SearchableConfigurationFilterInput
    $sort: [SearchableConfigurationSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableConfigurationAggregationInput]
  ) {
    searchConfigurations(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        storeId
        key
        value
        createdAt
        updatedAt
      }
    }
  }
`;

export const getCoupon = /* GraphQL */ `
  query GetCoupon($code: ID!) {
    getCoupon(code: $code) {
      id
      description
      code
      couponType
      buyXQuantity
      isAffiliated
      isPDPFeatured
      showAsNudge
      ppcodCouponAmount
      getYAmount
      getYPercentage
      getYQuantity
      getYProducts
      getYStoreProducts {
        id
        title
        price
      }
      minOrderValue
      maxDiscount
      expirationDate
      autoApply
      applicableCollections
      applicableProducts
      paymentMethod
    }
  }
`;

export const createOrder = /* GraphQL */ `
  mutation CreateNewOrder($input: CreateNewOrderInput!) {
    createOrder(input: $input) {
      id
      code
      storeId
      userId
      channelName
      totalStoreCredit
      couponCodeId
      totalAmount
      totalCashOnDeliveryCharges
      totalDiscount
      totalGiftCharges
      totalPrepaidAmount
      totalShippingCharges
      taxExempted
      cFormProvided
      thirdPartyShipping
      currency
      paymentType
      sla
      priority
      orderDate
      status
    }
  }
`;
export const getProductRecommendation = /* GraphQL */ `
  query GetProductRecommendation($input: ProductRecommendationInput!) {
    getProductRecommendation(input: $input) {
      productId
      variantId
    }
  }
`;

export const getCollectionType = /* GraphQL */ `
  query SearchCollectionTypes(
    $filter: SearchableCollectionTypeFilterInput
    $sort: [SearchableCollectionTypeSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCollectionTypeAggregationInput]
  ) {
    searchCollectionTypes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        slug
        defaultSorting
        isArchive
        imageUrl
        name
        showOutOfStockProducts
      }
    }
  }
`;

export const searchProductFaqs = /* GraphQL */ `
  query SearchProductFaqs(
    $filter: SearchableProductFaqFilterInput
    $sort: [SearchableProductFaqSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductFaqAggregationInput]
  ) {
    searchProductFaqs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        storeId
        productId
        title
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;

export const manageShoppingCart = /* GraphQL */ `
  mutation ManageShoppingCart($input: ManageShoppingCartInput!) {
    manageShoppingCart(input: $input) {
      success
      message
      shoppingCartId
    }
  }
`;

export const searchCollectionTypesForSitemap = /* GraphQL */ `
  query SearchCollectionTypes(
    $filter: SearchableCollectionTypeFilterInput
    $nextToken: String
  ) {
    searchCollectionTypes(filter: $filter, nextToken: $nextToken) {
      items {
        id
        slug
        updatedAt
        metadata {
          noIndex
          canonical
        }
      }
    }
  }
`;

export const searchProductsForSitemap = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $nextToken: String
  ) {
    searchProducts(filter: $filter, nextToken: $nextToken) {
      nextToken
      items {
        id
        slug
        updatedAt
        metadata {
          noIndex
          canonical
        }
      }
    }
  }
`;

export const sendAffiseAnalytics = /* GraphQL */ `
  mutation SendAffiseAnalytics($input: SendAffiseAnalyticsInput!) {
    sendAffiseAnalytics(input: $input) {
      success
      message
    }
  }
`;

export const ensureUserAndDispatchOTP = /* GraphQL */ `
  query EnsureUserAndDispatchOTP($storeId: ID!, $phone: AWSPhone!) {
    ensureUserAndDispatchOTP(storeId: $storeId, phone: $phone) {
      isExistingUser
    }
  }
`;

export const verifyCustomOTP = /* GraphQL */ `
  query VerifyCustomOTP($storeId: ID!, $phone: AWSPhone!, $otp: String!) {
    verifyCustomOTP(storeId: $storeId, phone: $phone, otp: $otp) {
      isVerified
    }
  }
`;

export const getCouponRule = /* GraphQL */ `
  query GetCouponRule($code: ID!, $storeId: ID!) {
    getCouponRule(code: $code, storeId: $storeId) {
      id
      code
      storeId
      prefix
      userId
      name
      description
      couponType
      deviceType
      expirationDate
      couponCodeCount
      getYStoreProducts {
        id
        title
        brand
        vendor
        collections
        categoryId
        subCategoryId
        storeId
        bulkActionId
        isFeatured
        productType
        createdAt
        slug
        pageTitle
        productDescription
        longDescription
        manufacturer
        updatedAt
        isPublished
        publishedAt
        price
        sku
        size
        color
        status
        position
        currency
        costPrice
        listingPrice
        taxable
        barcode
        tags
        benefits
        weight
        weightUnit
        minimumOrderQuantity
        inventory
        blockedInventory
        continueSellingOutOfStock
        rating
        totalRatings
        totalOrders
        thumbImages
        isTaxEnabled
        isInventoryEnabled
        googleCategory
        hasVarient
        hasFaq
        recommended
        recommendPriority
        recommendPrice
      }
      buyXQuantity
      getYAmount
      getYPercentage
      getYQuantity
      getYProducts
      minOrderValue
      maxDiscount
      maxAllowedUsage
      applicableCollections
      applicableProducts
      paymentMethod
      isArchive
      isFeatured
      isPDPFeatured
      isBulkCoupon
      autoApply
      isAffiliated
      showAsNudge
      ppcodCouponAmount
      createdAt
      updatedAt
      priority
      applyPrepaidDiscount
      applyOnAllVariants
      couponNote
      couponTitle
      tAndC
    }
  }
`;
